module.exports = __webpack_public_path__ + "static/media/free-code-camp.c57c7c51.svg";